import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    constructor(private http: HttpClient) { }

    getData(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}sequence`, filter);
    }

    getActivities(id: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}sequence/activities`, id);
    }

    getTasks(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}activities_dashboard/tasks`, filter);
    }

    deleteData(data: any): Observable<any> {
        return this.http.delete(`${environment.apiUrl}sequence/delete/${data._id}`, data);
    }

    activitiesSchedule(range: string, type: string, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/activities_schedule?range=${range}&type=${type}`, filter);
    }

    activitiesDistribution(range: string, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/activities_distribution?range=${range}`, filter);
    }

    activitiesSaleOffer(range: string, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/activities_sales_offers?range=${range}`, filter);
    }

    newAccounts(range: string, page: any, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/new_accounts?range=${range}&page=${page}`, filter);
    }

    accountsAssignments(range: string): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/accounts_assignments?range=${range}`, {});
    }

    updatedProperties(range: string, page: any, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/updated_properties?range=${range}&page=${page}`, filter);
    }

    updatedCommercialProperties(range: string, page: any, filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}dashboard/updated_commercial_properties?range=${range}&page=${page}`, filter);
    }

    changeStatus(data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.yiiUrl}activities/${data._id}`, data);
    }

    deleteActivity(id: any, createdBy: any, agency: any): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.yiiUrl}activities/${id}?created_by=${createdBy}&agency=${agency}`);
    }

    copyAcctivity(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.yiiUrl}activities`, data);
    }

    getMeetingsTours(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}activities_dashboard/meetings_tours`, filter);
    }

    //Procedure
    getProcedures(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}procedures`, filter);
    }

    createProcedure(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}procedures/create`, data);
    }

    updateProcedure(id: string, data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.apiUrl}procedures/update/${id}`, data);
    }

    deleteProcedure(id: string): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.apiUrl}procedures/delete/${id}`);
    }

    // Internal Policies
    getInternalPolicies(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}internal_policies`, filter);
    }

    createInternalPoliciy(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}internal_policies/create`, data);
    }

    updateInternalPolicy(id: string, data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.apiUrl}internal_policies/update/${id}`, data);
    }

    deleteInternalPolicy(id: string): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.apiUrl}internal_policies/delete/${id}`);
    }

    // Learning Resources
    getLearningResources(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}learning_resources`, filter);
    }

    createLearningResource(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}learning_resources/create`, data);
    }

    updateLearningResource(id: string, data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.apiUrl}learning_resources/update/${id}`, data);
    }

    deleteLearningResource(id: string): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.apiUrl}learning_resources/delete/${id}`);
    }
    getLearningResourceCategories(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}learning_resources/categories`);
    }
    // Individual Employee Status
    getIndividualEmployeeStatus(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}learning_statuses`, filter);
    }

    createIndividualEmployeeStatus(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}learning_statuses/create`, data);
    }

    updateIndividualEmployeeStatus(id: string, data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.apiUrl}learning_statuses/update/${id}`, data);
    }

    deleteIndividualEmployeeStatus(id: string): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.apiUrl}learning_statuses/delete/${id}`);
    }
    
    // AML Officer
    getAmlOfficers(filter: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}aml_officers`, filter);
    }

    createAmlOfficer(data: any): Observable<any[]> {
        return this.http.post<any[]>(`${environment.apiUrl}aml_officers/create`, data);
    }

    updateAmlOfficer(id: string, data: any): Observable<any[]> {
        return this.http.put<any[]>(`${environment.apiUrl}aml_officers/update/${id}`, data);
    }

    deleteAmlOfficer(id: string): Observable<any[]> {
        return this.http.delete<any[]>(`${environment.apiUrl}aml_officers/delete/${id}`);
    }
}
